import React, { useState } from 'react';
import { CloseIcon } from '../../assets/icons';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Images } from '../../config/images';
import { Modal, Button } from 'antd';
import { handleLogOutUser } from '../../utils/logOut';
import { resetUserData } from '../../store/reducer/accountSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const LogoutModal = (props) => {
  const { logoutModal, setLogoutModal, onSuccess = () => {} } = props;
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    setButtonLoading(true);
    const logOutResp = await handleLogOutUser();
    if (logOutResp) {
      setButtonLoading(false);
      setLogoutModal(false);
      await dispatch(resetUserData());
      localStorage.removeItem('redirectIntendedPage');
      onSuccess();
      navigate('/');
    }
  };

  return (
    <Modal open={logoutModal} onCancel={() => setLogoutModal(false)} width={524} footer={false} closeIcon={<CloseIcon />} centered>
      <div className='text-center mb-16'>
        <LazyLoadImage src={Images.logout} alt='door with arrow pointed towards it' />
      </div>
      <h4 className='text-center mb-16'>Log out of Realbricks</h4>
      <p className='text-center mb-48'>Are you sure you want to log out of your account?</p>
      <Button className='w-100' type='primary' onClick={handleLogOut} loading={buttonLoading}>
        Yes
      </Button>
    </Modal>
  );
};

export default LogoutModal;
